import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("cp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("cp_token");
      localStorage.removeItem("cp_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    if (err.response?.status === 403 && /somente consulta/i.test(err.response?.data?.detail || "")) {
      import("sonner").then(({ toast }) => toast.error(err.response.data.detail));
    }
    return Promise.reject(err);
  }
);

export const fmtDataBR = (iso) => {
  if (!iso || typeof iso !== "string") return "";
  if (iso.includes("undefined") || iso.includes("null")) return "";
  // 🆕 Já vem em formato BR (dd/mm/aaaa)? Devolve direto — backend permite
  //    salvar nos 2 formatos (ex.: importação CSV grava dd/mm/aaaa).
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(iso)) return iso;
  const d = iso.length >= 10 ? iso.slice(0, 10) : iso;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) return "";
  const [a, m, dd] = d.split("-");
  return `${dd}/${m}/${a}`;
};
export const fmtMin = (min) => {
  const s = Math.sign(min) < 0 ? "-" : "";
  const abs = Math.abs(min || 0);
  const h = Math.floor(abs / 60), m = abs % 60;
  return `${s}${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};
export const fmtNum = (n, d = 2) => Number(n || 0).toFixed(d).replace(".", ",");
